import { uiSettingRemoved } from "./uiSettingRemoved";
import { uiSettingUpdated } from "./uiSettingUpdated";
const updateUiSettingHandler = () => async ({ aggregateRoot, command }) => {
    const { aggregateId, key, value } = command;
    return {
        ...aggregateRoot,
        key,
        value,
        domainEvents: [uiSettingUpdated({ aggregateId })],
    };
};
const removeUiSettingHandler = () => async ({ aggregateRoot, command }) => {
    const { aggregateId } = command;
    return {
        ...aggregateRoot,
        domainEvents: [uiSettingRemoved({ aggregateId })],
    };
};
export { updateUiSettingHandler, removeUiSettingHandler };
